import { PieceAction } from '@apiContract';

import { useUpdatePiecesMutation } from '@api/piece';

import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { buildUpdatePiecesRequest } from './helper';
import { ActionComponentProps } from '../../index';

export const Delete = ({ mailpieces, actionStarted, onActionFinish, onClose }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();

  const runDeleteAction = async () => {
    try {
      const requestData = buildUpdatePiecesRequest({
        mailpieces,
        action: PieceAction.Delete,
      });
      await updatePieces(requestData).unwrap();
    } catch (error) {
      console.error(error);
    } finally {
      onActionFinish();
    }
  };

  const close = onClose ? onClose : onActionFinish;

  return (
    <DialogConfirmation
      maxWidth="xs"
      open={actionStarted}
      handleClose={close}
      title="Delete item"
      content="Are you sure you would like to permanently delete this item?"
      type="error"
      acceptButtonHandleClick={runDeleteAction}
      cancelButtonHandleClick={close}
      acceptButtonTitle="Delete"
      cancelButtonTitle="Cancel"
      loading={isLoading}
    />
  );
};
